<template>
  <div class="__help-popover-wrapper" :style="`margin-left: ${margin}px`">
    <el-popover placement="bottom" trigger="click" :width="width">
      <span class="__help-popover-content">
        <slot></slot>
      </span>
      <span slot="reference" @click="dialogVisible = true">
        <i class="fa fa-info-circle"></i>
      </span>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'HelpDialog',
  props: {
    margin: {
      type: String,
      default: '0',
    },
    width: {
      type: String,
      default: '400',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/mo-custom.scss';
.__help-popover-wrapper {
  display: inline-block;
  padding: 0 5px;
}
.__help-popover-content {
  word-break: break-word;
}
i {
  font-size: 0.8rem;
  color: $mute-color-darken;
  cursor: pointer;
}
</style>
<style>
.el-popover {
  z-index: 9999 !important;
}
</style>
